.tabs {
  margin-bottom: 16px;
}

.shareRow {
  flex: 1;
  display: flex;
}

.shareInput {
  flex: 1;
}

/* The share link sits last on the first screen, set apart from the people above it, and stays in view at the
 * dialog's foot however long the list of people is (GH #2698) */
.linkRow {
  position: sticky;
  /* Stick over the dialog content's 20px bottom padding (ui-lib dialog.module.css), so no row shows beneath */
  bottom: -20px;
  z-index: 1;
  padding-bottom: 20px;
  background: var(--tuna-palette-background-paper);
  display: flex;
  flex-flow: row wrap;
  gap: var(--tuna-spacing-1);
  align-items: center;
  justify-content: space-between;
  margin-top: var(--tuna-spacing-2);
  padding-top: var(--tuna-spacing-2);
  border-top: 1px solid var(--tuna-palette-divider);
  color: var(--tuna-palette-text-secondary);
}

.embedSection {
  display: flex;
  flex-direction: column;
}

.embedCodeRow {
  display: flex;
  flex-direction: row;
}

.suggestionList {
  margin-top: 4px;
  max-height: 280px;
  overflow-y: auto;
  border: 1px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-radius-sm);
}
